import { Fragment } from 'react'
import type { InlineNode, RichText } from '@/types/content'

function InlineView({ node }: { node: InlineNode }) {
  if (typeof node === 'string') return <>{node}</>

  switch (node.kind) {
    case 'link':
      return node.external === false ? (
        <a href={node.href}>{node.text}</a>
      ) : (
        <a href={node.href} target="_blank" rel="noopener noreferrer">
          {node.text}
        </a>
      )
    case 'em':
      return <em>{node.text}</em>
    case 'strong':
      return <strong>{node.text}</strong>
    case 'code':
      return <code>{node.text}</code>
    default: {
      const exhaustive: never = node
      return <>{String(exhaustive)}</>
    }
  }
}

/** Renders a `RichText` value: a plain string, or a run of inline nodes. */
export function RichTextView({ value }: { value: RichText }) {
  if (typeof value === 'string') return <>{value}</>
  return (
    <>
      {value.map((node, i) => (
        <Fragment key={i}>
          <InlineView node={node} />
        </Fragment>
      ))}
    </>
  )
}
